import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Config } from '../models/configuration.model';
import { AudioService } from './audio.service';
import { NavigatorService } from './navigator.service';


@Injectable({
  providedIn: 'root',
})


export class MultimodalService {

  public config: Config;

  // browser: any;


  constructor(@Inject(DOCUMENT) private document: Document, private audioService: AudioService, private navigatorService: NavigatorService) {
    this.config = new Config();
    // this.browser = this.navigatorService.identifyBrowser();
  }


  updateTheme(theme: string) {
    if (theme === 'dark-mode') {
      this.document.body.classList.add('dark-mode');
      this.document.getElementById('sidebar-menu').classList.add('dark-mode');
      this.document.getElementById('image-cursor').classList.add('darkMode');
      if (this.config.modalities[3].active) {
        this.document.getElementById('speech-balloon').classList.add('darkMode');
      }
    } else {
      this.document.body.classList.remove('dark-mode');
      this.document.getElementById('sidebar-menu').classList.remove('dark-mode');
      this.document.getElementById('image-cursor').classList.remove('darkMode');
      if (this.config.modalities[3].active) {
        this.document.getElementById('speech-balloon').classList.remove('darkMode');
      }
    }
  }



  loadAudio() {
    this.config.subtleClick = (this.document.getElementById('audio-click') as HTMLAudioElement);
    this.config.slideClick = (this.document.getElementById('audio-slide-click') as HTMLAudioElement);
    this.config.slideSound = (this.document.getElementById('audio-slide') as HTMLAudioElement);
    this.config.gateLatch = (this.document.getElementById('audio-gate-latch-click') as HTMLAudioElement);
    this.config.hardClick = (this.document.getElementById('audio-hard-click') as HTMLAudioElement);
    this.config.onOffSwitchSound = (this.document.getElementById('audio-on-off-light-switch') as HTMLAudioElement);
    this.config.lockSound = (this.document.getElementById('audio-lock-sound') as HTMLAudioElement);
  }


  playAudioClick() {
    if (this.config.modalities[2].active) { //only play when audio modality is activitated
      this.audioService.playSound(this.config.subtleClick);
    }
  }

  playAudioSlideClick() {
    if (this.config.modalities[2].active) {
      this.audioService.playSound(this.config.slideClick);
    }
  }

  playAudioSlide() {
    if (this.config.modalities[2].active) {
      this.config.slideSound.volume = 0.3;
      this.audioService.playSound(this.config.slideSound);
    }
  }

  playMechanicalClick() {
    if (this.config.modalities[2].active) {
      this.config.lockSound.volume = 0.3;
      this.audioService.playSound(this.config.lockSound);
    }
  }

  playHardClick() {
    if (this.config.modalities[2].active) {
      this.audioService.playSound(this.config.hardClick);
    }
  }

  playOnOffSwitch() {
    if (this.config.modalities[2].active) {
      this.audioService.playSound(this.config.onOffSwitchSound);
    }
  }

  playGateLatch() {
    if (this.config.modalities[2].active) {
      this.audioService.playSound(this.config.gateLatch);
    }
  }


  playHapticButtonClick(value: any) {
    if (window.navigator && window.navigator.vibrate) {
      if (this.config.modalities.filter(m => m.name === 'haptic')[0].active) {
        window.navigator.vibrate(value);
      }
    }
  }

}
